<template>
  <div>
    <!-- ── VegaWallet ── -->
    <form class="dep-form-frame" :class="{ 'colu-12 ga-4': !isMobile }">
      <div :class="isMobile ? 'colu colu-12 flex-colu' : 'colu colu-12'">
        <label class="colu-12 for-label" :for="`vega-uid-${uid}`">
          {{ $t('Bao.deposit_account') }}
        </label>
        <input
          :id="`vega-uid-${uid}`"
          :value="other.uid"
          :class="isMobile ? 'for-input inpType' : 'for-input'"
          type="text"
          :placeholder="$t('Bao.deposit_account')"
          @input="$emit('update:other', { ...other, uid: $event.target.value }); $emit('check-account-errors')"
        >
        <div v-for="error in accountErrors" :key="error" class="input-feedback text-align-R">
          {{ error }}
        </div>
      </div>
      <div :class="isMobile ? 'colu colu-12 flex-colu' : 'colu colu-12'">
        <label class="colu-12 for-label" :for="`vega-pw-${uid}`">
          {{ $t('Bao.deposit_password') }}
        </label>
        <input
          :id="`vega-pw-${uid}`"
          v-validate="'required'"
          :value="other.password"
          :class="isMobile ? 'for-input inpType' : 'for-input'"
          name="password"
          type="password"
          :placeholder="$t('Bao.deposit_password')"
          @input="$emit('update:other', { ...other, password: $event.target.value })"
        >
        <div v-if="errors.has('password')" class="input-feedback text-align-R">
          {{ $t('Bao.deposit_password_error') }}
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'DepositUseVega',
  inject: ['$validator'],
  props: {
    /** Vega 帳號密碼資料 */
    other: {
      type: [Array, Object],
      default: () => ({ uid: '', password: '' })
    },
    /** 錯誤陣列 */
    accountErrors: { type: Array, default: () => [] },
    /** Mobile 版 */
    isMobile: {
      type: Boolean,
      default: false
    },
    /**
     * 避免 Mobile / PC 同頁面時 label for 和 input id 重複。
     * 傳入 'mb' 或 'pc'。
     */
    uid: {
      type: String,
      default: 'pc'
    }
  },
  data() {
    return {

    }
  }
}
</script>
